import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../../styles/dashboardTheme.css";
import "../../../../styles/managementTheme.css";
import "../styles/bitacora.css";
import { showToast } from "../../../../utils/showToast";
import { usePermissions } from "../../../../utils/permissions";
import BitacoraHeader from "../components/BitacoraHeader";
import BitacoraTable from "../components/BitacoraTable";
import BitacoraModal from "../components/BitacoraModal";


export default function BitacoraView({
  filtroFecha,
  setFiltroFecha,
  alerta,
  setAlerta,
  filas,
  interesados,
  getBadgeClass,
  openNuevo,
  handleEditar,
  handleSalida,
  showModal,
  setShowModal,
  editando,
  tabActiva,
  setTabActiva,
  nuevoRegistro,
  setNuevoRegistro,
  fuentesLista,
  empresasLista,
  selectedCategoria,
  setSelectedCategoria,
  selectedSubcategoria,
  setSelectedSubcategoria,
  selectedAccion,
  setSelectedAccion,
  requiereReferido,
  fuenteHabilitaReferido,
  fuenteHabilitaEmpresa,
  referidosOpciones,
  referidoSearchTerm,
  setReferidoSearchTerm,
  cargandoReferidos,
  guardando,
  ocultarTransferir,
  categoriasLista,
  subcategoriasLista,
  accionesLista,
  handleGuardar,
  recargando,
  recargarDatos,
  buscarInteresado,
  bloquearInteresado,
  documentoBloqueado,
  setBloquearInteresado,
}) {
  const { hasPermission } = usePermissions();
  const canCreateRegistro = hasPermission("bitacora.crear");
  const canUpdateRegistro = hasPermission("bitacora.actualizar");
  const canCloseRegistro = hasPermission("bitacora.actualizar");
  const canConvert = hasPermission("estudiantes.crear");
  const normalize = (val = "") =>
    val
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  const accionEsInscripcion = normalize(selectedAccion) === "inscripcion";
  const showPreinscribir = accionEsInscripcion && canConvert;
  const disableTransfer = normalize(selectedAccion) === "informacion";
  const showTransfer = !disableTransfer && !ocultarTransferir;

  const handleNuevoSeguro = () => {
    if (!canCreateRegistro) {
      showToast({
        type: "warning",
        message: "No tienes permiso para crear registros.",
      });
      return;
    }
    openNuevo();
  };

  const handleEditarSeguro = (row) => {
    if (!canUpdateRegistro) {
      showToast({
        type: "warning",
        message: "No tienes permiso para editar registros.",
      });
      return;
    }
    handleEditar(row);
  };

  const handleSalidaSegura = (id) => {
    if (!canCloseRegistro) {
      showToast({
        type: "warning",
        message: "No tienes permiso para registrar salidas.",
      });
      return;
    }
    handleSalida(id);
  };

  useEffect(() => {
    if (alerta?.message) {
      showToast({
        type: alerta.type || "info",
        message: alerta.message,
        onClose: () => setAlerta({ message: "", type: "" }),
      });
    }
  }, [alerta, setAlerta]);

  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    if (showModal) document.body.classList.add("modal-open");
    else document.body.classList.remove("modal-open");
    return () => document.body.classList.remove("modal-open");
  }, [showModal]);

  return (
    <div className="dashboard-page management-page management-theme-teal container-fluid py-4">
      <BitacoraHeader
        filtroFecha={filtroFecha}
        onFechaChange={setFiltroFecha}
        onNuevo={handleNuevoSeguro}
        canCreate={canCreateRegistro}
      />

      <BitacoraTable
        filas={filas}
        interesados={interesados}
        getBadgeClass={getBadgeClass}
        onEdit={handleEditarSeguro}
        onSalida={handleSalidaSegura}
        canEdit={canUpdateRegistro}
        canClose={canCloseRegistro}
        recargarDatos={recargarDatos}
        recargando={recargando}
      />

      <BitacoraModal
        show={showModal}
        onClose={() => setShowModal(false)}
        tabActiva={tabActiva}
        setTabActiva={setTabActiva}
        editando={editando}
        nuevoRegistro={nuevoRegistro}
        setNuevoRegistro={setNuevoRegistro}
        fuentesLista={fuentesLista}
        empresasLista={empresasLista}
        categoriasLista={categoriasLista}
        subcategoriasLista={subcategoriasLista}
        accionesLista={accionesLista}
        selectedCategoria={selectedCategoria}
        setSelectedCategoria={setSelectedCategoria}
        selectedSubcategoria={selectedSubcategoria}
        setSelectedSubcategoria={setSelectedSubcategoria}
        selectedAccion={selectedAccion}
        setSelectedAccion={setSelectedAccion}
        requiereReferido={requiereReferido}
        fuenteHabilitaReferido={fuenteHabilitaReferido}
        fuenteHabilitaEmpresa={fuenteHabilitaEmpresa}
        referidosOpciones={referidosOpciones}
        referidoSearchTerm={referidoSearchTerm}
        setReferidoSearchTerm={setReferidoSearchTerm}
        cargandoReferidos={cargandoReferidos}
        guardando={guardando}
        showTransfer={showTransfer}
        showPreinscribir={showPreinscribir}
        handleGuardar={handleGuardar}
        buscarInteresado={buscarInteresado}
        bloquearInteresado={bloquearInteresado}
        documentoBloqueado={documentoBloqueado}
        setBloquearInteresado={setBloquearInteresado}
      />
    </div>
  );
}
